const React = require("react");
const withReDelay = require("mn-utils/withReDelay");
const {apiAdminRetailersList} = require("../../../../../../api/admin/retailers");
const {initFilter, getDefaultFilterParams, IntervalFilterAdmin, intervals} = require("../../../../../dumb/IntervalFilterCustom");
const AdminCell = require("../../../../../dumb/TableHeadCell/AdminCell");
const TableItem = require("./components/TableItem");

const filter$ = initFilter(intervals.INTERVAL_ALL_TIME);

module.exports = require('../../../../../../utils/virtualOutputComponentProvider')({
  state: {
    filter: filter$,
  },
  rowHeight: 60,
  request: apiAdminRetailersList,
  getParams: getDefaultFilterParams,
  wrapper(render, setState, self) {
    const update = withReDelay(self.update, 1000);
    function handleChangeFilter(filter) {
      filter$.emit({
        ...self.state.filter,
        ...filter,
      });
      update();
    }

    return (state) => {
      const filter = state.filter;
      const noData = !state.data || !state.data.count;

      return (
        <>
          <IntervalFilterAdmin
            className="mt20 m0@m"
            data={filter}
            onChange={handleChangeFilter}
            update={self.update}
            search={{
              className: 'wmin180 fx1',
              placeholder: 'Search',
            }}
          />
          <div className="rlv h100vh-325">
            <div className="ovxA abs s">
              <div className="wmin1150 rlv h">
                <div className="w abs bgE layoutRow aiStretch ov w1/6>1">
                  <AdminCell className="wmin100 fx1">
                    Retailer Name
                  </AdminCell>
                  <AdminCell className="wmin120 fx1">
                    Email
                  </AdminCell>
                  <AdminCell
                    className="wmin110 fx1"
                    // sortName="stage"
                    // self={self}
                  >
                    KYC Stage
                  </AdminCell>
                  <AdminCell
                    className="wmin100 fx1"
                    // sortName="created"
                    // self={self}
                  >
                    Created On
                  </AdminCell>
                  <AdminCell
                    className="wmin100 fx1"
                    // sortName="status"
                    // self={self}
                  >
                    Retailer Status
                  </AdminCell>
                  {/*<AdminCell className="wmin100 fx1" sortName="balance" self={self}>*/}
                  {/*  Fiat Balance<br/>(Available)*/}
                  {/*</AdminCell>*/}
                  <AdminCell
                    className="wmin100 fx1"
                    // sortName="balance"
                    // self={self}
                  >
                    Crypto Balance
                  </AdminCell>
                  {/*<AdminCell*/}
                  {/*  className="w100"*/}
                  {/*  // sortName="balance"*/}
                  {/*  // self={self}*/}
                  {/*>*/}
                  {/*  Action*/}
                  {/*</AdminCell>*/}
                </div>
                <div className="abs sh st45 sb c0>.CircularProgress">
                  {render(TableItem)}
                </div>
              </div>
            </div>
          </div>
        </>
      );
    };
  },
});
